export function createDeviceNode(device, position) {
  return {
    id: crypto.randomUUID(),
    type: "device",
    position,
    data: { device },
  };
}

export function createBoundaryNode(boundary, position) {
  return {
    id: crypto.randomUUID(),
    type: "signalBoundary",
    position,
    data: { boundary },
  };
}

export function createCanvasLabelNode(canvasLabel, position) {
  const w = canvasLabel.width || 300;
  const h = canvasLabel.height || 200;
  return {
    id: crypto.randomUUID(),
    type: "canvasLabel",
    position,
    data: { canvasLabel },
    width: w,
    height: h,
    style: { width: w, height: h },
    zIndex: -100 + (canvasLabel.sort_order || 0),
  };
}
